import React from 'react';
import styled from "styled-components";
import {colors} from "../../maps/colors";
import Button from "@mui/material/Button";

const WrapperStyled = styled.div`
    width: 420px;
    margin-top: 67px;
`;

const AlertBoxStyled = styled.div`
    padding: 20px;
    border-left: 3px solid;
    border-bottom-style: dashed;
    border-bottom-width: 2px;
    border-bottom-color: rgba(145, 158, 171, 0.2);
    

    &.INFO {
        border-color: ${colors.LIGHT_GREEN};
    }

    &.CRITICAL {
        border-color: ${colors.WARM_RED};
    }

    &.WARNING {
        border-color: ${colors.LIGHT_ORANGE};
    }
`;

const TitleStyled = styled.div`
    font-weight: 600;
    line-height: 1.57143;
    font-size: 0.875rem;
    font-family: "Public Sans", sans-serif;
`;

const MainTitleStyled = styled.div`
    font-weight: 700;
    line-height: 1.55556;
    font-size: 1.2625rem;
    font-family: "Public Sans", sans-serif;
    border-width: 0 0 thin;
    border-style: solid;
    border-color: rgba(145, 158, 171, 0.2);
    text-align: center;
    padding: 11px 0;
`;

const DateStyled = styled.div`
    display: flex;
    flex-direction: row;
    -webkit-box-align: center;
    align-items: center;
    line-height: 1.5;
    font-size: 0.75rem;
    font-family: "Public Sans", sans-serif;
    font-weight: 400;
    color: rgb(145, 158, 171);
`;

const MoreDataStyled = styled.div`
    line-height: 1.57143;
    font-size: 0.875rem;
    font-family: "Public Sans", sans-serif;
    font-weight: 400;
    margin: 0px;
`;

const ActionsStyled = styled.div`
  margin: 15px 0 0;
`;

const AlertsDrawerDisplay = () => {
    return (
        <WrapperStyled>
            <MainTitleStyled>Active Alerts</MainTitleStyled>
            <AlertBoxStyled className="INFO">
                <TitleStyled>Misplaced Product (A58) ---- <a href="">To Alerts</a></TitleStyled>
                <DateStyled>
                    1 min ago, 9:38 - 4 apr
                </DateStyled>
                <MoreDataStyled>
                    Field - 1, Shelf - A58
                </MoreDataStyled>
                <ActionsStyled>
                    <Button
                        color="info"
                        variant="contained"
                        size="small">Disable</Button>
                </ActionsStyled>
            </AlertBoxStyled>
            <AlertBoxStyled className="WARNING">
                <TitleStyled>Zero Line (A58)</TitleStyled>
                <DateStyled>
                    1 min ago, 9:38 - 4 apr
                </DateStyled>
                <MoreDataStyled>
                    Field - 1, Shelf - A58
                </MoreDataStyled>
            </AlertBoxStyled>
            <AlertBoxStyled className="CRITICAL">
                <TitleStyled>Reload Shelf (A58)</TitleStyled>
                <DateStyled>
                    1 min ago, 9:38 - 4 apr
                </DateStyled>
                <MoreDataStyled>
                    Field - 1, Shelf - A58
                </MoreDataStyled>
            </AlertBoxStyled>
        </WrapperStyled>
    );
};

export default AlertsDrawerDisplay;